export { default as FadeInOut } from './FadeInOut'
export { default as Wiggle } from './Wiggle'



// WEBPACK FOOTER //
// ./src/core/animations/index.js